import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { SolarOportunity } from 'entities/SolarOportunity';

export const solarOportunityApi = createApi({
  reducerPath: 'solarOportunityApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}`,
    prepareHeaders: (headers) => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          headers.set('Authorization', `Bearer ${JSON.parse(token)}`);
        }
      } catch (error) {
        console.warn('Error');
      }
      return headers;
    },
  }),
  tagTypes: ['SolarOportunity'],
  endpoints: (builder) => ({
    leadSolarOportunity: builder.mutation<
      { success: boolean },
      { data: SolarOportunity }
    >({
      query: ({ data }) => ({
        url: `/lp/solar-oportunity`,
        method: 'POST',
        mode: 'cors',
        body: data,
      }),
      invalidatesTags: ['SolarOportunity'],
    }),
  }),
});

export const { useLeadSolarOportunityMutation } = solarOportunityApi;
